import React, { useEffect } from "react"
import ImageGallery from "react-image-gallery"
import { ReactImageGalleryItem } from "react-image-gallery"
import "react-image-gallery/styles/css/image-gallery.css"

import styles from "./MonoImageGallery.module.css"

interface MonoImageGalleryProps {
  images: ReactImageGalleryItem[]
  ContainerClassName: string
}

const renderImage = (item) => {
  const screenWidth = window.innerWidth

  const height = screenWidth <= 900 ? "220px" : "360px"

  return (
    <img
      src={item.original}
      alt={""}
      style={{
        height,
        width: "100%",
        borderRadius: "6px",
        objectFit: "contain",
      }}
    />
  )
}

const MonoImageGallery = ({ images, ContainerClassName, ...rest }: MonoImageGalleryProps) => {
  images.map((obj: any) => {
    obj.thumbnailClass = `${styles.thumbnailContainer}`
  })

  return (
    <ImageGallery
      {...rest}
      items={images}
      showNav={false}
      lazyLoad
      showPlayButton={false}
      showFullscreenButton={false}
      additionalClass={`${styles.galleryContainer} ${ContainerClassName ?? ""}`}
      showThumbnails={images?.length > 1}
      renderItem={renderImage}
    />
  )
}

export default MonoImageGallery
